export default __webpack_public_path__ + "static/media/icon-consumer-payments.329b6c98.svg";